import { ReactNode } from "react";
import { Check } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@libs/zapi-ui/shadcn";
import { cn } from "@/zapi-frontend/shared/lib/utils";

export type TLanguageOption = {
  label: string;
  value: string;
};

type TLanguagePopoverProps = {
  children: ReactNode;
  options: TLanguageOption[];
  value?: string;
  onChange?: (value: string) => void;
  disabled?: boolean;
};

export function LanguagePopover({ children, options, value, onChange, disabled }: TLanguagePopoverProps) {
  if (disabled) return <>{children}</>;

  return (
    <Popover>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        align="start"
        sideOffset={6}
        className="w-[170px] p-1 rounded-lg shadow-300 border border-innoveraZinc-100"
      >
        <div className="flex flex-col gap-1">
          {options.map((option) => {
            const isSelected = option.value === value;
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => onChange?.(option.value)}
                data-testid={`language-popover-${option.value}-button`}
                className={cn(
                  "flex items-center gap-2 h-8 px-2 rounded-lg text-left text-innoveraZinc-900",
                  "text-[14px] leading-[13px] font-medium",
                  "hover:bg-innoveraZinc-50",
                  isSelected && "bg-innoveraZinc-50"
                )}
              >
                <Check className={cn("size-4 shrink-0", isSelected ? "opacity-100" : "opacity-0")} />
                <span className="truncate">{option.label}</span>
              </button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
